/* LogsViewComponent.js */

"use strict";

const BaseLogsViewComponent = require("../../../../../../lib/logs/BaseLogsViewComponent");
const Renderer = require("./LogsViewRenderer");
const _ = require("lodash");

class LogsViewComponent extends BaseLogsViewComponent {
    constructor(logger, gameEditor, state, io, storageFactory, MUF) {
        super(storageFactory);

        this._io = io;
        this._logger = logger;
        this._gameEditor = gameEditor;

        this._networkDiscoveryResultEntity = state.networkDiscoveryResultEntity;
        this._networkDiscoveryResultFeed = state.networkDiscoveryResultFeed;

        this._logFeed = undefined;

        this._renderer = new Renderer(this);
        this._modalUserFeedback = MUF;

        this._registerListeners();
    }

    switchResults(newResults) {
        this._unregisterLogFeedListeners();
        this._networkDiscoveryResultEntity = newResults;
        return this.whenModelIsReady();
    }

    whenModelIsReady() {
        return this._networkDiscoveryResultEntity.loadRelatedJobs().then((job) => {
            if (!_.isEmpty(job)) {
                const jobEntity = job[0];
                this._logFeed = jobEntity.startJobLogChangeFeed();
                this._registerLogFeedListeners();
                return this._logFeed.whenInitialized();
            }
        });
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerLogFeedListeners() {
        this._logFeed.on(
            "ElementsInitialized",
            (this._onLogsInitialized = this._onLogsInitialized.bind(this))
        );
        this._logFeed.on("ElementsAdded", (this._onLogsAdded = this._onLogsAdded.bind(this)));
    }

    _unregisterLogFeedListeners() {
        if (this._logFeed) {
            this._logFeed.removeListener("ElementsInitialized", this._onLogsInitialized);
            this._logFeed.removeListener("ElementsAdded", this._onLogsAdded);
        }
    }

    _registerListeners() {}

    _unregisterListeners() {
        this._unregisterLogFeedListeners();
    }

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/

    get device() {
        return this._device;
    }

    get logFile() {
        return this.getLogFile();
    }

    getLogFile() {
        return this._logFile;
    }

    get io() {
        return this._io;
    }

    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }

    retrieveJob() {
        return this._networkDiscoveryResultEntity.loadRelatedJobs().then((job) => {
            if (!_.isEmpty(job)) {
                const jobEntity = job[0];
                return Promise.resolve(jobEntity);
            }
            return Promise.resolve();
        });
    }

    shutdown() {
        this._unregisterListeners();
        let rendererShutdownProm = this._renderer._shutdown();
        let superClassShutdownProm = super.shutdown();
        let logFeedShutdownProm = this._logFeed ? this._logFeed.shutdown() : Promise.resolve();
        this._logger = undefined;
        this._gameEditor = undefined;
        return Promise.all([
            rendererShutdownProm,
            superClassShutdownProm,
            logFeedShutdownProm,
        ]).then(() => {
            this._renderer = undefined;
            this._logFeed = undefined;
        });
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START HANDLER METHODS                   */
    /*******************************************/

    _onLogsInitialized(logs) {
        this.emit("LogsInitialized", logs);
    }
    _onLogsAdded(logs) {
        this.emit("LogsAdded", logs);
    }

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    get gameEditor() {
        return this._gameEditor;
    }

    get logger() {
        return this._logger;
    }

    get logId() {
        return this.getLogId();
    }

    getLogId() {
        return this._logId;
    }

    get logFeed() {
        return this.getLogFeed();
    }

    getLogFeed() {
        return this._logFeed;
    }

    getLogs() {
        return _.get(this._model._logFeed, "logs", []);
    }

    // getDevices() {
    //     return _.values(this._gameEditor._pagingExecutionFeed.feed);
    // }

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /*******************************************/
}

module.exports = LogsViewComponent;

LogsViewComponent.$inject = [
    "$teve.logger",
    "gameEditor.gameEditor",
    "gameEditor.viewState",
    "$teve.io",
    "$teve.storageFactory",
    "$teve.ui.userFeedback",
];

LogsViewComponent.$displayDetails = {
    type: "View",
    name: "Network Discovery Log",
    icon: "common.edit",
    shown: false,
};
